// @flow

import { RestClientAuthenticated } from '../network';

const googleServicesApi = {
  fetchGAUuid: () => new RestClientAuthenticated('/api/google-services/analytics/uuid', 'GET').execute(),
  fetchMapsApiKey: () => new RestClientAuthenticated('/api/google-services/maps/apikey', 'GET').execute(),
  fetchCatchmentAreaStores: (
    pcCode: string, retailerId: number,
    lat: string, lng: string, codstr: number, retailerName: string,
  ) =>
    new RestClientAuthenticated('/api/google-services/catchment-area', 'GET')
      .addParam('pcCode', pcCode)
      .addParam('retailerId', retailerId)
      .addParam('location', `${lat},${lng}`)
      .addParam('codstr', codstr)
      .addParam('retailerName', retailerName)
      .execute(),
};

export default googleServicesApi;
